import toast from "react-hot-toast";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewRewardCouponList = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_REWARD_COUPON_LIST_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/reward-coupon/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_REWARD_COUPON_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_REWARD_COUPON_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_REWARD_COUPON_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewRewardCoupon = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_REWARD_COUPON_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.get(
        `${BASE_URL}/reward-coupon/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_REWARD_COUPON_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_REWARD_COUPON_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_REWARD_COUPON_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewRewardCoupon = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_NEW_REWARD_COUPON_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/reward-coupon/add`,
        payload,
        config
      );

      dispatch({ type: "ADD_NEW_REWARD_COUPON_SUCCESS", payload: data });
      return { statusCode: data.statusCode };
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error.message ||
        "Failed to add reward coupon";

      dispatch({ type: "ADD_NEW_REWARD_COUPON_FAILED", payload: errorMessage });
      throw error;
    }
  };
};

export const updateRewardCoupon = (id, payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_REWARD_COUPON_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/reward-coupon/update`,
        { id, ...payload },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_REWARD_COUPON_SUCCESS", payload: data });
        toast.success("Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_REWARD_COUPON_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_REWARD_COUPON_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};

export const changeRewardCouponStatus = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "CHANGE_REWARD_COUPON_STATUS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/reward-coupon/update-status`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "CHANGE_REWARD_COUPON_STATUS_SUCCESS", payload: data });
        toast.success("Changed Successfully!!");
        return data;
      } else {
        dispatch({ type: "CHANGE_REWARD_COUPON_STATUS_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "CHANGE_REWARD_COUPON_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};